import React, { useRef } from 'react';
import buttonWhoWeAre from '../assets/whoweare_01.png';
import buttonWhatWeDo from '../assets/whatwedo_01.png';
import buttonOurVision from '../assets/ourvision_01.png';
import './HomepageMain.css';

// 클릭 가능한 버튼 컴포넌트
const ClickableButton = ({ onClick, imgSrc, altText, className }) => (
    <div className={`menu-area-wrapper ${className}`}>
        <div className={`clickable-area ${className}`} onClick={onClick}>
            <img src={imgSrc} alt={altText}/>
        </div>
    </div>
);

const HomepageMain = () => {
    const sectionRefs = {
        whoWeAre: useRef(null),
        whatWeDo: useRef(null),
        ourVision: useRef(null),
        piesApp: useRef(null),
    };

    const scrollToSection = (section) => {
        if (sectionRefs[section].current) {
            window.scrollTo({
                top: sectionRefs[section].current.offsetTop,
                behavior: 'smooth',
            });
        }
    };
    const handleClick = (e, sectionName, xMin, xMax, yMin, yMax) => {
        // div의 크기와 위치를 기준으로 클릭 위치 계산
        const { offsetX, offsetY } = e.nativeEvent;
        const containerWidth = e.currentTarget.offsetWidth;
        const containerHeight = e.currentTarget.offsetHeight;

        // 화면의 비율로 변환 (각각의 비율을 계산)
        const xRatio = offsetX / containerWidth;
        const yRatio = offsetY / containerHeight;

        console.log(`클릭한 비율 좌표: xRatio = ${xRatio}, yRatio = ${yRatio}`);

        if (sectionName === 'footer') {
            if (xRatio >= 0.47 && xRatio <= 0.55 && yRatio >= 0.245 && yRatio <= 0.286) {
                scrollToSection('whoWeAre');
            }
            if (xRatio >= 0.47 && xRatio <= 0.55 && yRatio >= 0.371 && yRatio <= 0.41) {
                scrollToSection('whatWeDo');
            }
            if (xRatio >= 0.47 && xRatio <= 0.539 && yRatio >= 0.50 && yRatio <= 0.542) {
                scrollToSection('ourVision');
            }
            if (xRatio >= 0.82 && xRatio <= 0.935 && yRatio >= 0.48 && yRatio <= 0.63) {
                sendMail();
            }
        } else {
            // 클릭한 비율을 기반으로 특정 영역 클릭 여부를 결정
            if (xRatio >= xMin && xRatio <= xMax && yRatio >= yMin && yRatio <= yMax) {
                scrollToSection(sectionName);
            }
        }
    };

    const sendMail = () => {
        // 이메일 주소, 제목, 본문을 미리 설정하여 메일 작성
        const email = 'support@piespartners.com';
        const subject = '문의사항';
        const body = '안녕하세요.';
        const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        // mailto 링크 열기
        window.open(mailtoLink, '_blank');
    };


    return (
        <div className="background-container">
            {/* 로고 이미지 */}
            <ClickableButton
                imgSrc="/assets/logo.png"
                altText="Logo"
                className="logo-container"
            />
            {/* 각 배경 섹션 */}
            <div className="top">
                <img src="/assets/1_top(2).png" alt="Top"/>
            </div>

            <div className="wemusttake">
                <img src="/assets/2_wemusttake.png" alt="We Must Take"/>
            </div>

            <div className="start" onClick={(e) => handleClick(e, 'piesApp', 0.56, 0.66, 0.63, 0.66)}>
                <img src="/assets/3_start.png" alt="Start"/>
            </div>

            <div ref={sectionRefs.whoWeAre} className="whowe">
                <img src="/assets/4_1_whoweare.png" alt="Who We Are Section"/>
            </div>

            <div ref={sectionRefs.whatWeDo} className="whatwe">
                <img src="/assets/4_2_whatwedo(1).png" alt="What We Do Section"/>
            </div>

            {/*<div ref={sectionRefs.piesApp} className="piesapp">*/}
            {/*    <img src="/assets/5_piesapp.png" alt="pies app"/>*/}
            {/*</div>*/}

            <div ref={sectionRefs.ourVision} className="vision">
                <img src="/assets/6_ourvision(2).png" alt="vision Section"/>
            </div>

            {/*<div className="ourteam">*/}
            {/*    <img src="/assets/identity.png" alt="team"/>*/}
            {/*</div>*/}

            <div className="footer" onClick={(e) => handleClick(e, 'footer', 0.47, 0.55, 0.245, 0.286)}>
                <img src="/assets/8_footer.png" alt="footer"/>
            </div>

            {/* 클릭 가능한 버튼들 */}
            <ClickableButton
                onClick={() => scrollToSection('whoWeAre')}
                imgSrc={buttonWhoWeAre}
                altText="Who We Are"
                className="whoweare"
            />

            <ClickableButton
                onClick={() => scrollToSection('whatWeDo')}
                imgSrc={buttonWhatWeDo}
                altText="What We Do"
                className="whatwedo"
            />

            <ClickableButton
                onClick={() => scrollToSection('ourVision')}
                imgSrc={buttonOurVision}
                altText="Our Vision"
                className="ourvision"
            />

            {/* Back to Top 버튼 */}
            <div className="back-to-top" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}>
                <img src="/assets/gotop.png" alt="GoTop"/>
            </div>
        </div>
    );
};

export default HomepageMain;
